(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gammes-fan"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-gammes-fan')) {
 customElements.define('vv-gammes-fan', class extends HTMLElement {
  connectedCallback() {
   if (this.life) return;
   this.life = new AbortController();
   const signal = this.life.signal;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   const show = () => { this.setAttribute('data-entered',''); this.observer?.disconnect(); };
   const settle = () => { this.removeAttribute('data-armed'); show(); };
   this.motion.addEventListener('change', settle, {signal});
   const scope = this.closest('.shopify-section') || this;
   scope.addEventListener('shopify:section:load', settle, {signal});
   scope.addEventListener('shopify:section:select', settle, {signal});
   scope.addEventListener('shopify:block:select', settle, {signal});
   scope.addEventListener('shopify:section:unload', () => this.disconnectedCallback(), {signal});
   this.addEventListener('focusin', settle, {signal});
   if (this.dataset.animation !== 'true' || this.motion.matches || !('IntersectionObserver' in window)) { settle(); return; }
   this.removeAttribute('data-entered');
   this.setAttribute('data-armed','');
   this.observer = new IntersectionObserver(entries => { if(entries[0].isIntersecting) show(); }, {rootMargin:'0px 0px -40px 0px',threshold:0});
   this.observer.observe(this);
  }
  disconnectedCallback() { this.life?.abort(); this.life=null; this.observer?.disconnect(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-interactive"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-newsletter-interactive')) {
  customElements.define('vv-newsletter-interactive', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      const reveal = () => { this.setAttribute('data-revealed', ''); this.observer?.disconnect(); };
      if (this.dataset.animation === 'true' && !this.reduce.matches && !window.Shopify?.designMode && !this.hasAttribute('data-revealed')) {
        this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) reveal(); }, { threshold: .12 });
        this.setAttribute('data-armed', '');
        this.observer.observe(this);
      } else reveal();
      this.reduce.addEventListener('change', () => { reveal(); this.resetTilt(); }, { signal });
      this.pointer.addEventListener('change', () => this.resetTilt(), { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:load', reveal, { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.cleanup(), { signal });
      this.area = this.querySelector('.vv-newsletter__tilt-area');
      this.image = this.querySelector('.vv-newsletter__tilt-image');
      this.current = [0,0,1]; this.target = [0,0,1];
      if (!this.area || this.dataset.tilt !== 'true') return;
      this.area.addEventListener('pointerenter', () => { this.bounds = this.area.getBoundingClientRect(); }, { signal });
      this.area.addEventListener('pointermove', event => {
        if (!this.pointer.matches || this.reduce.matches || !this.bounds) return;
        const amount = Math.min(18, Math.max(0, Number(this.dataset.intensity) || 0));
        const x = Math.max(-1,Math.min(1,(event.clientX-this.bounds.left)/this.bounds.width*2-1));
        const y = Math.max(-1,Math.min(1,(event.clientY-this.bounds.top)/this.bounds.height*2-1));
        this.target = [-y*amount,x*amount,1.18]; this.animateTilt();
      }, { signal, passive:true });
      this.area.addEventListener('pointerleave', () => { this.target=[0,0,1];this.bounds=null;this.animateTilt(); }, { signal });
      this.area.addEventListener('pointercancel', () => this.resetTilt(), { signal });
    }
    animateTilt() {
      if (this.frame) return;
      const tick = time => {
        const ease = 1-Math.exp(-Math.min(50,this.lastTime ? time-this.lastTime : 16)/70);
        this.lastTime=time;
        this.current=this.current.map((value,i)=>value+(this.target[i]-value)*ease);
        this.image.style.setProperty('--vv-n-rx',this.current[0]+'deg');
        this.image.style.setProperty('--vv-n-ry',this.current[1]+'deg');
        this.image.style.setProperty('--vv-n-scale',this.current[2]);
        if(this.current.some((value,i)=>Math.abs(value-this.target[i])>.001)) this.frame=requestAnimationFrame(tick);
        else {this.frame=0;this.lastTime=0;}
      };
      this.frame=requestAnimationFrame(tick);
    }
    resetTilt(){cancelAnimationFrame(this.frame);this.frame=0;this.lastTime=0;this.bounds=null;this.current=[0,0,1];this.target=[0,0,1];['--vv-n-rx','--vv-n-ry','--vv-n-scale'].forEach(name=>this.image?.style.removeProperty(name));}
    cleanup(){this.controller?.abort();this.observer?.disconnect();this.resetTilt();}
    disconnectedCallback(){this.cleanup();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-advice"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-advice')) {
  customElements.define('vv-advice', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(min-width: 1051px) and (hover: hover) and (pointer: fine)');
      this.visual = this.querySelector('.vv-advice__visual');
      const settle = () => { this.removeAttribute('data-entering'); this.reset(); };
      this.reduce.addEventListener('change', settle, { signal });
      this.pointer.addEventListener('change', () => this.reset(), { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:select', settle, { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.cleanup(), { signal });
      if (this.dataset.animation === 'true' && !this.reduce.matches && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.setAttribute('data-entering', '');
            this.observer.disconnect();
          }
        }, { threshold: .12 });
        this.observer.observe(this);
      }
      if (this.dataset.parallax === 'true') {
        this.visual.addEventListener('pointerenter', () => { this.bounds = this.visual.getBoundingClientRect(); }, { signal });
        this.visual.addEventListener('pointermove', event => {
          if (this.reduce.matches || !this.pointer.matches || !this.bounds) return;
          this.x = Math.max(-3, Math.min(3, ((event.clientX - this.bounds.left) / this.bounds.width - .5) * 6));
          this.y = Math.max(-3, Math.min(3, ((event.clientY - this.bounds.top) / this.bounds.height - .5) * 6));
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.visual.style.setProperty('--vv-x', this.x + 'px');
            this.visual.style.setProperty('--vv-y', this.y + 'px');
            this.frame = 0;
          });
        }, { signal, passive: true });
        this.visual.addEventListener('pointerleave', () => this.reset(), { signal });
      }
    }
    reset() { cancelAnimationFrame(this.frame); this.frame = 0; this.bounds = null; this.visual?.style.removeProperty('--vv-x'); this.visual?.style.removeProperty('--vv-y'); }
    cleanup() { this.abort?.abort(); this.observer?.disconnect(); this.reset(); }
    disconnectedCallback() { this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-duo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-duo')) {
  customElements.define('vv-duo', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.pointer = matchMedia('(min-width: 1051px) and (hover: hover) and (pointer: fine)');
      this.visual = this.querySelector('.vv-duo__visual');
      const settle = () => { this.removeAttribute('data-entering'); this.reset(); };
      this.reduce.addEventListener('change', settle, { signal });
      this.pointer.addEventListener('change', () => this.reset(), { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:select', settle, { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.cleanup(), { signal });
      if (this.dataset.animation === 'true' && !this.reduce.matches && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.setAttribute('data-entering', '');
            this.observer.disconnect();
          }
        }, { threshold: .12 });
        this.observer.observe(this);
      }
      if (this.dataset.parallax === 'true') {
        this.visual.addEventListener('pointerenter', () => { this.bounds = this.visual.getBoundingClientRect(); }, { signal });
        this.visual.addEventListener('pointermove', event => {
          if (this.reduce.matches || !this.pointer.matches || !this.bounds) return;
          this.x = Math.max(-3, Math.min(3, ((event.clientX - this.bounds.left) / this.bounds.width - .5) * 6));
          this.y = Math.max(-3, Math.min(3, ((event.clientY - this.bounds.top) / this.bounds.height - .5) * 6));
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.visual.style.setProperty('--vv-x', this.x + 'px');
            this.visual.style.setProperty('--vv-y', this.y + 'px');
            this.frame = 0;
          });
        }, { signal, passive: true });
        this.visual.addEventListener('pointerleave', () => this.reset(), { signal });
      }
    }
    reset() { cancelAnimationFrame(this.frame); this.frame = 0; this.bounds = null; this.visual?.style.removeProperty('--vv-x'); this.visual?.style.removeProperty('--vv-y'); }
    cleanup() { this.abort?.abort(); this.observer?.disconnect(); this.reset(); }
    disconnectedCallback() { this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-immersive-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-immersive-hero')) {
  customElements.define('vv-immersive-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const media = matchMedia('(min-width: 1100px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      const reset = () => {
        cancelAnimationFrame(this.frame);
        this.style.setProperty('--vv-x', '0px');
        this.style.setProperty('--vv-y', '0px');
      };
      const update = () => {
        this.enabled = media.matches && this.dataset.motion === 'true' && Number(this.dataset.intensity) > 0;
        reset();
      };
      media.addEventListener('change', update, { signal });
      update();
      this.addEventListener('pointermove', event => {
        if (!this.enabled || this.dataset.active !== 'true') return;
        const rect = this.getBoundingClientRect();
        const intensity = Number(this.dataset.intensity);
        const x = ((event.clientX - rect.left) / rect.width - .5) * intensity * 2;
        const y = ((event.clientY - rect.top) / rect.height - .5) * intensity * 1.2;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.style.setProperty('--vv-x', `${x}px`);
          this.style.setProperty('--vv-y', `${y}px`);
        });
      }, { passive: true, signal });
      this.addEventListener('pointerleave', reset, { signal });
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        this.dataset.active = String(entries[0].isIntersecting && !document.hidden);
        if (this.dataset.active !== 'true') reset();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.dataset.active = 'false'; reset(); }
        else { this.observer.unobserve(this); this.observer.observe(this); }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-trust"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vv-trust')) customElements.define('vv-trust',class extends HTMLElement{
 connectedCallback(){
  this.observer?.disconnect();this.controller?.abort();this.controller=new AbortController();
  const reveal=()=>{this.setAttribute('data-visible','');this.observer?.disconnect()};
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  reduced.addEventListener('change',reveal,{signal:this.controller.signal});
  if(this.dataset.animate==='true'&&!reduced.matches&&!window.Shopify?.designMode&&!this.hasAttribute('data-visible')){
   this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))reveal()},{threshold:.15});
   this.setAttribute('data-armed','');this.observer.observe(this);
  }else reveal();
 }
 disconnectedCallback(){this.observer?.disconnect();this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
